import React, { useMemo, useState, useRef } from 'react';

import { categories } from 'constants/tests';
import MultiSelectCheckboxDropdown from 'components/MultiSelectDropdownCheckbox/MultiSelectDropdownCheckbox';
import { Modal, Header, Body, Footer, FooterButton } from './modalElements';
import { TextInput, HideTestCategoriesContainer, FlexContainer, ErrorMessage } from 'pages/SettingsPage/styles';

export default React.memo(({ testPackageModalInfo, testsAvailable, updateTestPackage, close }) => {
  const [testPackage, setTestPackage] = useState(testPackageModalInfo);
  const [error, setError] = useState('');

  const selectedTests = useRef({
    [categories.CODE.category]: [],
    [categories.MULTICHOICE.category]: [],
    [categories.GENERAL_SKILLS.category]: [],
  });

  const codeTestOptions = useMemo(() => {
    let code = {};
    for (const key in testsAvailable[categories.CODE.category]) {
      if (testsAvailable[categories.CODE.category][key].isPremium) continue;
      if (testPackageModalInfo.tests.includes(key)) {
        selectedTests.current = {
          ...selectedTests.current,
          [categories.CODE.category]: [...selectedTests.current[categories.CODE.category], key],
        };
        code[key] = { ...testsAvailable[categories.CODE.category][key], selected: true };
      } else {
        code[key] = { ...testsAvailable[categories.CODE.category][key], selected: false };
      }
    }
    return code;
  }, [testPackageModalInfo.tests, testsAvailable]);

  const mcpTestOptions = useMemo(() => {
    let mcp = {};
    let mcpTests = {
      isCandidateChoosesEnabled: {
        label: 'Candidate Chooses',
        value: 'isCandidateChoosesEnabled',
      },
      ...testsAvailable[categories.MULTICHOICE.category],
    };
    for (const key in mcpTests) {
      if (testPackageModalInfo.tests.includes(key)) {
        selectedTests.current = {
          ...selectedTests.current,
          [categories.MULTICHOICE.category]: [...selectedTests.current[categories.MULTICHOICE.category], key],
        };
        mcp[key] = { ...mcpTests[key], selected: true };
      } else {
        mcp[key] = { ...mcpTests[key], selected: false };
      }
    }
    return mcp;
  }, [testPackageModalInfo.tests, testsAvailable]);

  const generalSkillsTestOptions = useMemo(() => {
    let generalSkills = {};
    for (const key in testsAvailable[categories.GENERAL_SKILLS.category]) {
      if (testPackageModalInfo.tests.includes(key)) {
        selectedTests.current = {
          ...selectedTests.current,
          [categories.GENERAL_SKILLS.category]: [...selectedTests.current[categories.GENERAL_SKILLS.category], key],
        };
        generalSkills[key] = { ...testsAvailable[categories.GENERAL_SKILLS.category][key], selected: true };
      } else {
        generalSkills[key] = { ...testsAvailable[categories.GENERAL_SKILLS.category][key], selected: false };
      }
    }
    return generalSkills;
  }, [testPackageModalInfo.tests, testsAvailable]);

  const updateTests = (category, tests) => (selectedTests.current = { ...selectedTests.current, [category]: tests });

  const updatePackage = () => {
    testPackage.tests = [
      ...selectedTests.current[categories.CODE.category],
      ...selectedTests.current[categories.MULTICHOICE.category],
      ...selectedTests.current[categories.GENERAL_SKILLS.category],
    ];
    if (!testPackage.name) return setError('Name is required');
    if (!testPackage.tests.length) return setError('Please select at least one test');
    updateTestPackage(testPackage);
  };

  return (
    <Modal>
      <Header>Tests Package</Header>
      <Body noOverflow>
        <TextInput
          isEditing={true}
          height="30px"
          margin="0 0 10px"
          placeholder="Package name"
          onChange={(e) => setTestPackage({ ...testPackage, name: e.target.value })}
          value={testPackage.name}
        />
        <HideTestCategoriesContainer>
          <FlexContainer>
            <MultiSelectCheckboxDropdown
              title="Freecode: "
              options={codeTestOptions}
              onSelect={(value) => updateTests('code', value)}
            />
          </FlexContainer>
          <FlexContainer>
            <MultiSelectCheckboxDropdown
              title="Multichoice: "
              options={mcpTestOptions}
              onSelect={(value) => updateTests('Multiple Choice Programming', value)}
            />
          </FlexContainer>
          <FlexContainer>
            <MultiSelectCheckboxDropdown
              title="General Skills: "
              options={generalSkillsTestOptions}
              onSelect={(value) => updateTests('General Skills', value)}
            />
          </FlexContainer>
        </HideTestCategoriesContainer>
        {error && (
          <ErrorMessage noMargin padding="10px 0 0">
            {error}
          </ErrorMessage>
        )}
      </Body>
      <Footer>
        <FooterButton label="Close" onClick={() => close()} />
        <FooterButton label={testPackageModalInfo._id ? 'Update' : 'Add'} onClick={() => updatePackage()} />
      </Footer>
    </Modal>
  );
});
